import React from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    Slider,
    Typography,
    withStyles,
} from '@material-ui/core';
import { enabledField, valueText } from '../index';

const styles = (theme) => ({
    divider: {
        margin: theme.spacing(1),
    },
    formControl: {
        width: '100%',
    },
    smartScore: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    presetSmartScoreInput: {
        display: 'flex',
        alignItems: 'center',
    },
    presetSmartScore: {
        marginLeft: '10px',
    },
});

const PresetWorkVerifierSettings = (props) => {
    const { classes, translations, handleChange, values, setFieldValue } = props;

    const fieldNames = {
        AutoShutdown: `AutoShutdown`,
        AutoStartVerification: `AutoStartVerification`,
        VerificationPercentDone: `VerificationPercentDone`,
        NormalScreenBrightness: `NormalScreenBrightness`,
        ReducedScreenBrightness: `ReducedScreenBrightness`,
        // AssetsToVerifyPercent: `AssetsToVerifyPercent`,
    };

    const fieldValues = {
        AutoShutdown: values['AutoShutdown'],
        AutoStartVerification: values['AutoStartVerification'],
        VerificationPercentDone: values['VerificationPercentDone'],
        NormalScreenBrightness: values['NormalScreenBrightness'],
        ReducedScreenBrightness: values['ReducedScreenBrightness'],
        // AssetsToVerifyPercent: values['AssetsToVerifyPercent'],
    };

    return (
        <>
            <Typography align="center" variant={'h5'}>
                {translations['work_verifier_presets'] || 'Work Verifier Presets'}
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoShutdown']}
                            checked={fieldValues['AutoShutdown'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${
                        translations['auto_shut_down_after_successful_verification'] ||
                        'Auto shut down after successful verification'
                    }`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoStartVerification']}
                            checked={fieldValues['AutoStartVerification'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['auto_start_verification'] || 'Auto start verification'}`}
                />
            </FormGroup>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['verification_threshold_per_storage_in_percent'] ||
                        'Verification threshold per storage in percent'}
                </InputLabel>
                <br />
                <Slider
                    name={fieldNames['VerificationPercentDone']}
                    value={fieldValues['VerificationPercentDone']}
                    valueLabelFormat={valueText}
                    onChange={(event, value) => setFieldValue(fieldNames['VerificationPercentDone'], value)}
                    valueLabelDisplay="on"
                    aria-labelledby="discrete-slider"
                    step={1}
                    marks
                    min={1}
                    max={100}
                    disabled={enabledField(values)}
                />
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['normal_screen_brightness'] ||
                        'Please choose normal screen brightness (e.g. after login, while entering data)'}
                </InputLabel>
                <br />
                <Slider
                    name={fieldNames['NormalScreenBrightness']}
                    value={fieldValues['NormalScreenBrightness']}
                    valueLabelFormat={valueText}
                    onChange={(event, value) => setFieldValue(fieldNames['NormalScreenBrightness'], value)}
                    valueLabelDisplay="on"
                    aria-labelledby="discrete-slider"
                    step={1}
                    marks
                    min={20}
                    max={100}
                    disabled={enabledField(values)}
                />
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['reduced_screen_brightness'] ||
                        'Please choose reduced screen brightness (e.g. during screensaver is visible)'}
                </InputLabel>
                <br />
                <Slider
                    name={fieldNames['ReducedScreenBrightness']}
                    value={fieldValues['ReducedScreenBrightness']}
                    valueLabelFormat={valueText}
                    onChange={(event, value) => setFieldValue(fieldNames['ReducedScreenBrightness'], value)}
                    valueLabelDisplay="on"
                    aria-labelledby="discrete-slider"
                    step={1}
                    marks
                    min={0}
                    max={100}
                    disabled={enabledField(values)}
                />
            </FormControl>
        </>
    );
};

export default withStyles(styles, { withTheme: true })(PresetWorkVerifierSettings);
